import React, { useCallback, useEffect, useState } from 'react'
import apiClient from '../../services/api'
import { useToast } from '../../context/ToastContext'
import LoadingSpinner from '../../components/LoadingSpinner'
import { defaultSiteSettings } from '../../hooks/useSiteSettings'

const presetFields = [
  { name: 'siteName', label: 'Clinic Name', placeholder: 'Harmony Medical Clinic' },
  { name: 'siteTagline', label: 'Footer Tagline', placeholder: 'Short clinic tagline' },
  { name: 'contactPhone', label: 'Phone', placeholder: '(555) 678-9101' },
  { name: 'contactEmail', label: 'Email', placeholder: 'info@clinic.com' },
  { name: 'contactAddress', label: 'Address', placeholder: '123 Health Blvd, Springfield, IL 62704' },
  { name: 'contactHoursWeekdays', label: 'Weekday Hours', placeholder: 'Mon - Fri: 8:00 AM to 7:00 PM' },
  { name: 'contactHoursSaturday', label: 'Saturday Hours', placeholder: 'Saturday: 9:00 AM to 3:00 PM' },
  { name: 'contactHoursSunday', label: 'Sunday Hours', placeholder: 'Sunday: Emergency support only' },
  { name: 'facebookUrl', label: 'Facebook URL', placeholder: 'https://facebook.com/your-page' },
  { name: 'instagramUrl', label: 'Instagram URL', placeholder: 'https://instagram.com/your-page' },
  { name: 'twitterUrl', label: 'Twitter URL', placeholder: 'https://twitter.com/your-page' }
]

const arrayToMap = (items) =>
  items.reduce((acc, item) => {
    acc[item.name] = item.value || ''
    return acc
  }, { ...defaultSiteSettings })

const AdminSettings = () => {
  const [form, setForm] = useState({})
  const [loading, setLoading] = useState(true)
  const { addToast } = useToast()

  const load = useCallback(async () => {
    try {
      const res = await apiClient.get('/api/cms/settings')
      setForm(arrayToMap(res.data))
    } catch (e) { addToast('Error loading settings', 'danger') } finally { setLoading(false) }
  }, [addToast])

  useEffect(() => {
    load()
  }, [load])

  const savePresetFields = async (e) => {
    e.preventDefault()
    try {
      await Promise.all(
        presetFields.map((field) =>
          apiClient.put(`/api/cms/settings/${encodeURIComponent(field.name)}`, {
            value: form[field.name] || ''
          })
        )
      )
      addToast('Settings saved', 'success')
      load()
    } catch (e) {
      addToast('Error saving settings', 'danger')
    }
  }

  if (loading) return <LoadingSpinner />

  return (
    <div>
      {/* <div className="admin-page-header">
        <div>
          <h2>Site Settings</h2>
          <p>
            Update the clinic details shown across the public site and keep custom keys available for future CMS-driven sections.
          </p>
        </div>
      </div> */}

      <form className="row g-3 mb-4" onSubmit={savePresetFields}>
        {presetFields.map((field) => (
          <div key={field.name} className="col-md-6">
            <label className="form-label">{field.label}</label>
            <input
              className="form-control"
              placeholder={field.placeholder}
              value={form[field.name] || ''}
              onChange={(e) => setForm((prev) => ({ ...prev, [field.name]: e.target.value }))}
            />
          </div>
        ))}
        <div className="col-12">
          <button className="btn btn-primary" type="submit">Save Main Settings</button>
        </div>
      </form>
    </div>
  )
}

export default AdminSettings
